import React from 'react';

import { SVGComponentProps } from './svg.types';

const LinkedInSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        id="master-artboard"
        viewBox="0 0 734.3944091796875 735.7957153320312"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={size}
        height={size}
        {...otherProps}
      >
        <rect id="ee-background" x="0" y="0" width={size} height={size} fill="white" />
        <g transform="matrix(20.39933967590332, 0, 0, 20.39933967590332, -121.85619256556481, -121.68631744384766)">
          <path
            fill="#0078d4"
            d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5&#9;V37z"
          />
          <path
            fill="#fff"
            d="M12,19h5v17h-5V19z M14.485,17h-0.028C12.965,17,12,15.888,12,14.499C12,13.08,12.995,12,14.514,12&#9;c1.521,0,2.458,1.08,2.486,2.499C17,15.887,16.035,17,14.485,17z M36,36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698&#9;c-1.501,0-2.313,1.012-2.707,1.99C24.957,25.543,25,26.511,25,27v9h-5V19h5v2.616C25.721,20.5,26.85,19,29.738,19&#9;c3.578,0,6.261,2.25,6.261,7.274L36,36L36,36z"
          />
        </g>
      </svg>
    </span>
  );
};

export default LinkedInSVG;
